import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import type { DropdownOption } from '~/types/components/product-listing/sort/sort.types'

export const useProductListingSortStore = defineStore(
  'productListingSortStore',
  () => {
    const route = useRoute()
    const { t } = useNuxtApp().$i18n

    const sortOptions = ref([
      {
        value: 'sales',
        label: t('products.featured'),
        isSelected: false,
        isDisabled: false,
      },
      {
        value: 'published_at',
        label: t('products.newest'),
        isSelected: false,
        isDisabled: false,
      },
      {
        value: 'rating',
        label: t('products.topRated'),
        isSelected: false,
        isDisabled: false,
      },
      {
        value: 'price',
        label: t('products.priceLowToHigh'),
        isSelected: false,
        isDisabled: false,
      },
      {
        value: '-price',
        label: t('products.priceHighToLow'),
        isSelected: false,
        isDisabled: false,
      },
    ])

    const DEFAULT_SORT = ref(sortOptions.value[0].value)

    const selectedSortOption = ref(
      route.query.sort?.toString() || DEFAULT_SORT.value
    )

    function updateSortByOptionsDefault(sort: string) {
      sortOptions.value = sortOptions.value.map((opt: DropdownOption) => ({
        ...opt,
        isSelected: opt.value === sort,
      }))
      selectedSortOption.value = sort
    }

    function isValidSort(sort: string) {
      return sortOptions.value.some((opt: DropdownOption) => opt.value === sort)
    }

    updateSortByOptionsDefault(selectedSortOption.value)

    return {
      DEFAULT_SORT,
      sortOptions,
      selectedSortOption,
      isValidSort,
      updateSortByOptionsDefault,
    }
  }
)
